// 福利商城
export const zwyHotelRouter = [
  {
    path: '/service/zwy/hotel/list',
    name: 'ZwyHotelConnection',
    component: () => import('@/views/service/serviceProvider/zwyHotel/ZwyHotelConnection'),
    meta: {
      title: '自我游酒店直连',
      keepAlive: false
    }
  },
  {
    path: '/service/zwy/hotel/direct',
    name: 'ZwyHotelDirectOrder',
    component: () => import('@/views/service/serviceProvider/zwyHotel/ZwyHotelDirectOrder.vue'),
    meta: {
      title: '自我游订单直连',
      keepAlive: true
    }
  },
  {
    path: '/service/zwy/hotel/associatedAccount',
    name: 'ZwyHotelAssociatedAccount',
    component: () => import('@/views/service/serviceProvider/zwyHotel/ZwyHotelAssociatedAccount.vue'),
    meta: {
      title: '关联账号',
      keepAlive: false
    }
  }
]
